// Constants for image quality and effects
export const IMAGE_QUALITY = {
  placeholder: 10,
  mobile: 70,
  tablet: 75,
  desktop: 80,
} as const;

export const PLACEHOLDER_BLUR = 20;
export const NO_IMAGE_URL =
  'https://media.simplywall.st/news/1706674307668-no-image.png';
export const DEFAULT_USER_NAME = 'Simply Wall St User';

// Mobile-optimized image configuration
export const MOBILE_IMAGE_CONFIG = {
  micro: { mobile: 16, tablet: 18, desktop: 20 },
  xs: { mobile: 24, tablet: 26, desktop: 28 },
  sm: { mobile: 32, tablet: 36, desktop: 40 },
  md: { mobile: 48, tablet: 52, desktop: 56 },
  lg: { mobile: 56, tablet: 60, desktop: 64 },
} as const;

// Helper functions
export const generateInitials = (
  displayName: string | null | undefined
): string => {
  const name = displayName || DEFAULT_USER_NAME;
  return name.substring(0, 2).toUpperCase();
};

export const hasValidAvatar = (
  imageUrl: string | null | undefined
): boolean => {
  return Boolean(imageUrl && imageUrl !== NO_IMAGE_URL);
};

export const createResponsiveBreakpoints = (
  mobileSize: number,
  tabletSize: number,
  desktopSize: number
) => [
  // Mobile (1x)
  { width: mobileSize, height: mobileSize, quality: IMAGE_QUALITY.mobile },
  // Tablet (1x)
  { width: tabletSize, height: tabletSize, quality: IMAGE_QUALITY.tablet },
  // Desktop (1x)
  { width: desktopSize, height: desktopSize, quality: IMAGE_QUALITY.desktop },
  // Mobile (2x for high-DPI)
  {
    width: mobileSize * 2,
    height: mobileSize * 2,
    quality: IMAGE_QUALITY.mobile,
  },
  // Tablet (2x for high-DPI)
  {
    width: tabletSize * 2,
    height: tabletSize * 2,
    quality: IMAGE_QUALITY.tablet,
  },
  // Desktop (2x for high-DPI)
  {
    width: desktopSize * 2,
    height: desktopSize * 2,
    quality: IMAGE_QUALITY.desktop,
  },
];

export const getImageSizes = (size: keyof typeof MOBILE_IMAGE_CONFIG) => {
  return MOBILE_IMAGE_CONFIG[size] || MOBILE_IMAGE_CONFIG.sm;
};
